module.exports = __webpack_public_path__ + "img/27d686681fd84c961222e9507f6945ee.png";